import { type ReactElement } from 'react';
import Turnstile from 'react-turnstile';

import config from '@/config';
import { type Language } from '@/lib/utils/language';

type Props = {
  language: Language;
  onVerify: (token: string) => void;
  includeMargin?: boolean;
};

export const TurnstileFormToken = ({
  includeMargin = true,
  ...props
}: Props): ReactElement => (
  <Turnstile
    fixedSize
    refreshExpired="auto"
    sitekey={config.turnstile.siteKey}
    size="flexible"
    {...(includeMargin && { style: { marginTop: '1rem' } })}
    {...props}
  />
);
